import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import actions from './actions';
import selector from './selector';

import AdobeLayout from './layout';

const handleSearch = (keywords, dispatch) => {
    dispatch(actions.getAudiences(keywords));
};

const AdobeDashboard = ({ dispatch, audienceSegments, totalSegmentCount, isLoading, ...props }) => {
    useEffect(() => {
        dispatch(actions.init());
    }, [1]);

    const onChange = value => {
        handleSearch(value, dispatch);
    };

    return (
        <AdobeLayout
            audienceSegments={audienceSegments}
            onSearch={onChange}
            segmentCount={totalSegmentCount}
            isLoading={isLoading}
            activeAudience={props.params.audienceId}
            organizationId={props.organizationId}
        />
    );
};

export default connect(selector)(AdobeDashboard);
